import React from 'react';

import Input from 'routes/app/components/Input';
import TimeSlotModal from './TimeSlotModal';

import 'stylesheets/components/timeslotpicker.scss';


class TimeSlotPicker extends React.Component {

    static propTypes = {
        translateFn: React.PropTypes.func.isRequired,
        onChange: React.PropTypes.func.isRequired,
        onDateChange: React.PropTypes.func.isRequired,
        data: React.PropTypes.object.isRequired,
        config: React.PropTypes.object.isRequired
    };

    render() {
        let {...props} = this.props;

        return (
            <Input
                suffix={<TimeSlotModal {...props} />}
                ref="inputEl"
                {...props} />
        );
    }

}


export default TimeSlotPicker;
